<template>
	<el-menu class="sidebar" router :default-active="activeSideBarIndex">
		<template v-for="(item,index) in $store.state.sideBar">
			<!-- 有下级菜单 -->
			<el-submenu v-if="item.children.length > 0" :key="index" :index='item.url'>
				<template slot="title">
					<i :class="item.icon || 'el-icon-menu'"></i>
					<span>{{item.name}}</span>
				</template>
				<el-menu-item @click="onSiderMenu(item2.url)" v-for="(item2,index2) in item.children" :key="index2" :index="item2.url">
					<i :class="item2.icon || 'el-icon-menu'"></i>
					<span>{{item2.name}}</span>
				</el-menu-item>
			</el-submenu>
			<!-- 无下级菜单 -->
			<el-menu-item v-else @click="onSiderMenu(item.url)" :key="index" :index="item.url">
				<i :class="item.icon || 'el-icon-menu'"></i>
				<span slot="title">{{item.name}}</span>
			</el-menu-item>
		</template>
	</el-menu>
</template>

<script>
	import {
		mapState,
		mapMutations
	} from 'vuex';
	export default {
		data() {
			return {
				activeSideBarIndex: ""
			};
		},
		created() {
			this.activeSideBarIndex = localStorage.getItem("activeSideBarIndex");
		},
		methods: {
			onSiderMenu(url) {
				localStorage.setItem("activeSideBarIndex", url);
			}
		}
	}
</script>

<style scoped>
</style>
